import React, { Component } from 'react'
import {SelectDropdownStyle} from './../styles'
import {ArrowDrop} from './'

export default class SelectDropdown extends Component {
  state = {
    open: false,
    value: '',
  }

  handlerClick = () => {
    this.setState({ open: !this.state.open })
  }

  updateSelect = (select) => (e) => {
    e.preventDefault()
    this.setState({ value: select, open: !this.state.open }, () => {
      this.props.callback(this.state.value)
    })
  }

  render () {
    const { label, lists } = this.props
    const { open, value } = this.state
    return (
      <div className={`${SelectDropdownStyle(open, value)} dropdown`}>
        <div className="dropdown-label" onClick={this.handlerClick}> { value !== '' ? value : label } <ArrowDrop width={16} height={16} /> </div>
        <ul className="reset dropdown-list">
          {lists && Object.keys(lists).map((key, i) => (
              <li key={i} onClick={this.updateSelect(Object.keys(lists)[i])} className={ value === Object.keys(lists)[i] ? 'active' : '' }> 
                {Object.keys(lists)[i]} 
              </li>
            ))
          }
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SelectDropdown.js